// extracted by mini-css-extract-plugin
export default {"menuHeight":"72px","nav-dropdown":"nav-dropdown_nav-dropdown__MFxYd","nav-dropdown--active":"nav-dropdown_nav-dropdown--active__yBm5T"};